// A $( document ).ready() block.
$( document ).ready(function() {
    $(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 25) {
        $(".shopify-section.header").addClass("isSticky");
    } else {
        $(".shopify-section.header").removeClass("isSticky");
    }
});
});

/*For lead time notice inside the product info PDP 7-29-2024*/
$( document ).ready(function() {
  setTimeout(function() { 
    $("#inside-product-info").insertAfter(".template-product .purchase-box .selection-wrapper.price");
    $("#inside-product-info").css("opacity","1");
  }, 3500);
});


/*For news and promotions section on homepage hide/show arrows 8-21-2024*/
$( document ).ready(function() {
  setTimeout(function() { 
  var promotionSlideCount = $("#two-banners").data("slide-count");
    if(promotionSlideCount === 1){
      $("#two-banners .flickity-page-dots").attr("style", "display: none !important;");
      $("#two-banners .flickity-prev-next-button").attr("style", "display: none !important;");
    }  
  }, 1500);
});

/*For main banner slider homepage 9-27-2024*/
$(document).ready(function() {
  setTimeout(function() {
    var promotionSlideCountHome = $("#static-banner .slideshow-carousel").data("slide-count");
    
    // Create a style element
    var style = $('<style>');
    var css = "";

    if (promotionSlideCountHome === 1) {
      css += "#static-banner .flickity-page-dots { display: none !important; }";
      css += "#static-banner .flickity-prev-next-button { display: none !important; }";
      css += "#static-banner .slide__item.slide__item-image.is-selected { left: 0px !important; }";
    } else {
      css += "#static-banner .slide__item.slide__item-image.is-selected { left: 100% !important; }";
    }

    // Append CSS to style element and add it to head
    style.text(css);
    $('head').append(style);

  }, 1500);
});

/*Social media links open in new tab 11-19-2024*/
 $(document).ready(function() {
    document.querySelectorAll('.site-header-wrapper ul.social-icons li a').forEach(function(link) {
        link.setAttribute('target', '_blank');
    });
 });



